/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Button, Row, Col, Typography } from 'antd';

const { Title } = Typography;

const styles = {
  title: {
    color: '#404047',
    fontWeight: '700',
    fontSize: '24px',
    margin: 0,
    marginBottom: 8,
    lineHeight: '29px',
    textAlign: 'center'
  },
  subtitle: {
    color: '#8C8C8C',
    letterSpacing: '0.02em',
    fontSize: 14,
    textAlign: 'center',
    fontWeight: '300'
  },
  span: {
    background: "#15A9E1", 
    borderRadius: "32px", 
    padding: "5px 12px",
    fontWeight: "700", 
    fontSize: "14px", 
    lineHeight: "22px", 
    textAlign: "center", 
    color: "#FFFFFF"
  }
}

function MobileHeaderScreening({count, step, title, subtitle}) {
  const { t } = useTranslation(['sign-up']);
  return (
    <>
      <Row justify="center" style={{ padding: 0, marginBottom: 20 }}>
        <Box style={styles.span}>
          {t('sign-up:guest.step')} {step} {t('sign-up:guest.of')} {count}
        </Box>
      </Row>
      <Row justify="center" style={{ padding: 0, marginBottom: 28 }}>
        <Col>
          <Title level={4} style={styles.title}>
            {title}
          </Title>
          <p style={styles.subtitle}>
            {subtitle}
          </p>
        </Col>
      </Row>
    </>
  );
}

MobileHeaderScreening.defaultProps = {
  count: 1,
  step: 1,
  title: '',
  subtitle: ''
};

const { number, string } = PropTypes;

MobileHeaderScreening.propTypes = {
  count: number,
  step: number,
  title: string,
  subtitle: string
};

export default MobileHeaderScreening;
